import { render, staticRenderFns } from "./updateEmail.vue?vue&type=template&id=4055413b&"
import script from "./updateEmail.vue?vue&type=script&lang=js&"
export * from "./updateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports